import type { Clock, Random } from '../../application/ports.ts'

export const systemClock: Clock = {
  now: () => new Date(),
}

export const systemRandom: Random = {
  float: () => {
    const [drawn = 0] = globalThis.crypto.getRandomValues(new Uint32Array(1))
    return drawn / 2 ** 32
  },
  id: () => globalThis.crypto.randomUUID(),
}

/** A clock that can be wound by hand. Used in tests and in the meeting replay. */
export function fixedClock(instants: readonly Date[]): Clock {
  let index = 0
  return {
    now: () => instants[Math.min(index++, instants.length - 1)] ?? new Date(0),
  }
}

/** Deterministic draws and ids, for tests. */
export function seededRandom(seed: number, prefix = 'id'): Random {
  let state = seed >>> 0
  let counter = 0
  const next = (): number => {
    state = (state * 1664525 + 1013904223) >>> 0
    return state / 2 ** 32
  }
  return {
    float: next,
    id: () => `${prefix}-${++counter}`,
  }
}
